import React from 'react';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import makeStyles from '@mui/styles/makeStyles';
import {theme} from '../Theme';

const useStyles = makeStyles(() => ({
  container: {
    top: 'auto',
    bottom: 0,
    padding: window.outerWidth > 600 ? '12px 24px' : '12px 16px',
    borderTop: `1px solid ${theme.palette.gray.border}`,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function FixedFooter(props: $TSFixMe) {
  const classes = useStyles();

  const buttonContainer = (
    <Grid
      container
      alignItems="center"
      justifyContent={
        props.justifyContent ? props.justifyContent : 'space-between'
      }>
      {props.children}
    </Grid>
  );

  return (
    <>
      {props.appbar ? (
        <AppBar className={classes.container} style={props.style}>
          {buttonContainer}
        </AppBar>
      ) : (
        <Toolbar className={classes.container} style={props.style}>
          {buttonContainer}
        </Toolbar>
      )}
    </>
  );
}
